var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1149 14.533C16.2093 14.2331 15.2524 14.2324 14.3457 14.5319L14.991 16.8921L14.4993 22.0615L15.7286 24L16.9579 22.0615L16.4661 16.8921L17.1149 14.533Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6523 13.4475C18.3561 12.7418 19.1652 10.7885 18.4594 9.08478C17.7537 7.38105 15.8004 6.57201 14.0967 7.27775C12.3929 7.98349 11.5838 9.93675 12.2895 11.6405C12.9953 13.3442 14.9485 14.1533 16.6523 13.4475Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.355 22.8081H30.2473V21.053C30.2473 17.8676 27.6653 15.2856 24.4799 15.2856C23.1522 15.2856 21.9301 15.7336 20.9551 16.4882",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4303 14.4776C27.5075 13.4004 27.5075 11.6539 26.4303 10.5768C25.3531 9.4996 23.6067 9.4996 22.5295 10.5768C21.4523 11.6539 21.4523 13.4004 22.5295 14.4776C23.6067 15.5547 25.3531 15.5547 26.4303 14.4776Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39223 22.8081H0.5V21.053C0.5 17.8676 3.08199 15.2856 6.2674 15.2856C7.59509 15.2856 8.81716 15.7336 9.79218 16.4882",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94987 13.1623C9.29994 11.6797 8.3819 10.1941 6.89936 9.84402C5.41682 9.49395 3.93119 10.412 3.58112 11.8945C3.23105 13.3771 4.1491 14.8627 5.63164 15.2128C7.11418 15.5628 8.59981 14.6448 8.94987 13.1623Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4277 21.21V22.8083",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53516 21.21V22.8083",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3193 21.21V22.8083",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2119 21.21V22.8083",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3741 13.7017C11.5183 13.7017 8.39258 16.8274 8.39258 20.6832V22.808H22.3557V20.6832C22.3557 16.8274 19.2299 13.7017 15.3741 13.7017Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffSvg);
export default __webpack_public_path__ + "static/media/staff-svg.f259afdb3fd47be667fba29428cc89b2.svg";
export { ForwardRef as ReactComponent };